import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import './Sidebar.css';

const Sidebar = ({ isOpen, onItemClick }) => {
  const { user } = useAuth();
  const role = String(user?.role || '').toLowerCase().trim();

  // Define routes based on user role
  const getMenuItems = () => {
    // Menu for admin
    if (['admin', 'super_admin'].includes(role)) {
      return [
        { path: '/dashboard', label: 'Dashboard', icon: 'bi bi-grid' },
        // { path: '/mis-dashboard', label: 'MIS Dashboard', icon: 'bi bi-bar-chart-line-fill' },
        { path: '/project-tracker', label: 'MIS Dashboard', icon: 'bi bi-kanban-fill', adminOnly: true },
        { path: '/task-management', label: 'Task Management', icon: 'bi bi-list-check' },
        // { path: '/manager/attendance-requests', label: 'Attendance Requests', icon: 'bi bi-list-check' },
        // { path: '/allocation', label: 'Allocate Task', icon: 'bi bi-grid' },
        { path: '/client', label: 'My Clients', icon: 'bi bi-people-fill' },
        { path: '/myprojects', label: 'My Projects', icon: 'bi bi-journal-check' },
        { path: '/employees', label: 'My Employees', icon: 'bi bi-person' },
        // { path: '/reports', label: 'Reports', icon: 'bi bi-clipboard2-check' },
        { path: '/employee-kpi-admin', label: 'Employee KPI', icon: 'bi bi-person-lines-fill', isEmployeeKpi: true },
        { path: '/kpi-reports', label: 'KPI Reports', icon: 'bi bi-file-earmark-bar-graph' },
        { path: '/documents', label: 'Documents', icon: 'bi bi-file-earmark-pdf' },
        // { path: '/kpi', label: 'KPI', icon: 'bi bi-file-earmark-text' },
        // { path: '/getsuggestion', label: 'Get Suggestion', icon: 'bi bi-lightbulb' },
        // { path: '/ticketing', label: 'Ticket', icon: 'bi bi-clipboard2-check' },
        // { path: '/ta', label: 'Travel Allowance', icon: 'bi bi-briefcase' },
        { path: '/policies', label: 'Policies', icon: 'bi bi-calendar2-check' },
        { path: '/induction', label: 'Induction', icon: 'bi bi-book' },
        { path: '/feedback', label: 'Feedback', icon: 'bi bi-chat-left-text' },
      ];
    }

    // Menu for team lead
    if (['team lead', 'teamlead', 'tl'].includes(role)) {
      return [
        { path: '/dashboard', label: 'Dashboard', icon: 'bi bi-grid' },
        { path: '/task-management', label: 'Task Management', icon: 'bi bi-list-check' },
        { path: '/mis-tracker', label: 'MIS Tracker', icon: 'bi bi-kanban' },
        // { path: '/manager/attendance-requests', label: 'Attendance Requests', icon: 'bi bi-list-check' },
        { path: '/myprojects', label: 'My Projects', icon: 'bi bi-journal-check' },
        { path: '/employees', label: 'My Employees', icon: 'bi bi-person' },
        // { path: '/reports', label: 'Reports', icon: 'bi bi-clipboard2-check' },
        { path: '/client', label: 'My Clients', icon: 'bi bi-people-fill' },
        { path: '/employee-kpi', label: 'My KPI', icon: 'bi bi-calendar2-check' },
        { path: '/employee-kpi-admin', label: 'Employee KPI', icon: 'bi bi-person-lines-fill', isEmployeeKpi: true },
        { path: '/documents', label: 'Documents', icon: 'bi bi-file-earmark-pdf' },
        // { path: '/documents', label: 'Documents', icon: 'bi bi-file-earmark-pdf' },
        // { path: '/ta', label: 'Travel Allowance', icon: 'bi bi-briefcase' },
        { path: '/policies', label: 'Policies', icon: 'bi bi-calendar2-check' },
        // { path: '/ticketing', label: 'Ticket', icon: 'bi bi-clipboard2-check' },
        { path: '/induction', label: 'Induction', icon: 'bi bi-book' },
        { path: '/feedback', label: 'Feedback', icon: 'bi bi-chat-left-text' },
      ];
    }

    // Menu for hod
    if (role === 'hod') {
      return [
        { path: '/dashboard', label: 'Dashboard', icon: 'bi bi-grid' },
        { path: '/task-management', label: 'Task Management', icon: 'bi bi-list-check' },
        { path: '/mis-tracker', label: 'MIS Tracker', icon: 'bi bi-kanban' },
        // { path: '/manager/attendance-requests', label: 'Attendance Requests', icon: 'bi bi-list-check' },
        { path: '/myprojects', label: 'My Projects', icon: 'bi bi-journal-check' },
        { path: '/employees', label: 'My Employees', icon: 'bi bi-person' },
        // { path: '/reports', label: 'Reports', icon: 'bi bi-clipboard2-check' },
        { path: '/client', label: 'My Clients', icon: 'bi bi-people-fill' },
        { path: '/employee-kpi', label: 'My KPI', icon: 'bi bi-calendar2-check' },
        { path: '/employee-kpi-admin', label: 'Employee KPI', icon: 'bi bi-person-lines-fill', isEmployeeKpi: true },
        { path: '/documents', label: 'Documents', icon: 'bi bi-file-earmark-pdf' },
        // { path: '/kpi', label: 'KPI', icon: 'bi bi-file-earmark-text' },
        // { path: '/documents', label: 'Documents', icon: 'bi bi-file-earmark-pdf' },
        // { path: '/ta', label: 'Travel Allowance', icon: 'bi bi-briefcase' },
        { path: '/policies', label: 'Policies', icon: 'bi bi-calendar2-check' },
        // { path: '/ticketing', label: 'Ticket', icon: 'bi bi-clipboard2-check' },
        { path: '/induction', label: 'Induction', icon: 'bi bi-book' },
        { path: '/feedback', label: 'Feedback', icon: 'bi bi-chat-left-text' },
      ];
    }

    // Menu for employee (default)
    return [
      { path: '/dashboard', label: 'Dashboard', icon: 'bi bi-grid' },
      { path: '/task-management', label: 'Task Management', icon: 'bi bi-list-check' },
      { path: '/mis-tracker', label: 'MIS Tracker', icon: 'bi bi-kanban' },
      { path: '/myprojects', label: 'My Projects', icon: 'bi bi-journal-check' },
      { path: '/client', label: 'Clients', icon: 'bi bi-people-fill' },
      // { path: '/reports', label: 'Reports', icon: 'bi bi-clipboard2-check' },
      // Only My KPI for employee
      { path: '/employee-kpi', label: 'My KPI', icon: 'bi bi-calendar2-check' },
      { path: '/documents', label: 'Documents', icon: 'bi bi-file-earmark-pdf' },
      // { path: '/documents', label: 'Documents', icon: 'bi bi-file-earmark-pdf' },
      // { path: '/ta', label: 'Travel Allowance', icon: 'bi bi-briefcase' },
      { path: '/policies', label: 'Policies', icon: 'bi bi-calendar2-check' },
      // { path: '/ticketing', label: 'Ticket', icon: 'bi bi-clipboard2-check' },
      { path: '/induction', label: 'Induction', icon: 'bi bi-book' },
      { path: '/feedback', label: 'Feedback', icon: 'bi bi-chat-left-text' },
    ];
  };

  const navigate = useNavigate();

  const handleNavigate = (e, path) => {
    e.preventDefault();
    navigate(path);
    if (onItemClick) {
      onItemClick();
    }
  };

  const location = useLocation();

  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`} id="sidebar">
      <div className="sidebar-brand">
        <span className="sidebar-brand-mark"><i className="bi bi-grid-1x2-fill"></i></span>
        <span className="sidebar-brand-text">Workspace</span>
      </div>

      <ul className="sidebar-nav" id="sidebar-nav">
        {getMenuItems().map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <li className="nav-item" key={item.path}>
              <Link
                className={`nav-link${isActive ? ' active' : ''}`}
                to={item.path}
                onClick={(e) => handleNavigate(e, item.path)}
              >
                <span className="nav-icon"><i className={item.icon}></i></span>
                <span className="nav-label">{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default Sidebar;
